<app-entity-follow-up-flag *ngIf="entity"
                           [cornerFlag]="true"
                           [entityId]="entity?.id"
                           [campaignId]="entity?.campaignContextId">
</app-entity-follow-up-flag>
<div class="person"
     *ngIf="entity">

  <div class="person__main">
    <div class="person__header p-0075 pt-0050 pb-0050">
      <app-entity-avatar [assessmentLevel]="entity.currentAssessmentLevel"
                         [spotlightIcon]="entity.spotlightIcon"
                         [isUser]="entity.linkedUserId"
                         [entityId]="entity.id"
                         [entityTypeId]="entity.entityTypeId"
                         [campaignId]="entity.campaignContextId"
                         [size]="'sm'">
      </app-entity-avatar>
      <h2 class="h2 person__detail">
        <span class="person__name txt-16">{{entity | fullName }}</span>
        <app-highlighted-topline *ngIf="showToplines"
                                 [targetId]="entity.id"
                                 [targetType]="'Entity'"
                                 [campaignId]="entity.campaignContextId"
                                 [parentEntityId]="entity.id"
                                 [topline]="entity.appliedToplines?.item0"
                                 class="d-block w-auto">
        </app-highlighted-topline>
      </h2>
    </div>
  </div>

</div>
